import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

/**
 * Resolve the largest available image URL from an img element.
 */
function getFullImageUrl(img) {
  const srcset = img.getAttribute('srcset');
  if (srcset) {
    const sources = srcset.split(',').map((entry) => entry.trim().split(/\s+/));
    let bestUrl = img.src;
    let bestWidth = 0;

    sources.forEach(([url, widthDescriptor]) => {
      const width = parseInt(widthDescriptor, 10) || 0;
      if (width > bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });

    return bestUrl;
  }

  return img.currentSrc || img.src;
}

/**
 * Prepare WordPress gallery images inside .portfolio-images-grid for lightbox.
 */
function preparePortfolioGridLinks(root) {
  root.querySelectorAll('.wp-block-image').forEach((figure) => {
    const img = figure.querySelector('img');
    if (!img) {
      return;
    }

    const existingLink = figure.querySelector('a[href]');
    if (existingLink) {
      existingLink.classList.add('glightbox');
      existingLink.dataset.gallery = root.dataset.galleryId || 'portfolio-gallery';
      return;
    }

    const link = document.createElement('a');
    link.href = getFullImageUrl(img);
    link.className = 'glightbox portfolio-images-grid__link';
    link.dataset.gallery = root.dataset.galleryId || 'portfolio-gallery';
    link.setAttribute('aria-label', img.alt || 'View image');

    img.parentNode.insertBefore(link, img);
    link.appendChild(img);
  });
}

const lightboxInstances = new Map();

function initLightbox(selector, options = {}) {
  if (lightboxInstances.has(selector)) {
    return lightboxInstances.get(selector);
  }

  const instance = GLightbox({
    selector,
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    openEffect: 'fade',
    closeEffect: 'fade',
    ...options,
  });

  lightboxInstances.set(selector, instance);
  return instance;
}

export function initGalleryLightbox() {
  document.querySelectorAll('.portfolio-images-grid').forEach((grid, index) => {
    if (!grid.dataset.galleryId) {
      grid.dataset.galleryId = `portfolio-gallery-${index + 1}`;
    }
    preparePortfolioGridLinks(grid);
  });

  if (document.querySelector('.gallery-masonry .glightbox')) {
    initLightbox('.gallery-masonry .glightbox');
  }

  if (document.querySelector('.portfolio-images-grid .glightbox')) {
    initLightbox('.portfolio-images-grid .glightbox');
  }
}
